import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {CommonUtil, LoginService, UploadService} from '@serengeti/serengeti-common';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../navigation/navigation.service';
import { getDashboardActiveState, getOauthLoginActiveState, getTokenActiveState } from 'src/app/app.module';
// import { AuthService, SocialUser } from 'angularx-social-login';
import { ThemeService } from 'src/app/setting/theme/service/theme.service';
import {NotificationService} from '@serengeti/serengeti-notification';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: [
		'./menu.component.scss'
	]
})
export class MenuComponent implements OnInit {

	@Input() hideDropdown = true;
	_menus: any[];
	@Input() set menus(_menus: any[]) {
		if (_menus) {
			this.handleMenuVisibility(_menus);

			this._menus = _menus;

			if (this.navigationService.links && this.navigationService.links.length > 0) {
				for (let index = this.navigationService.links.length - 1; index >= 0; index --) {
					const current = this.navigationService.links[index];

					for (const menu of _menus) {
						const selectedMenu = this.findTopMenuFromUrl(menu.children, current.url, menu);

						if (selectedMenu) {
							this.selectedMenu = selectedMenu;
							return;
						}
					}
				}
			}
		} else {
			this._menus = _menus;
		}
	}
	get menus(): any[] {
		return this._menus;
	}

	_numberOfNotification = 0;
	@Input() set numberOfNotification(_numberOfNotification: number) {
		this._numberOfNotification = _numberOfNotification;

		if (_numberOfNotification >= 100) {
			this._numberOfNotification = 99;
			this.notificationLimitExceeded = true;
		} else {
			this._numberOfNotification = _numberOfNotification;
		}
	};
	get numberOfNotification() {
		return this._numberOfNotification;
	}

	numberOfTickets = 0;

	login: any;
	loginId: string;
	loginName: string;

	notificationLimitExceeded = false;
	selectedMenu: any;

	profile: any;
	version: any;
	guideUrl: string;
	menuNavigation = 'sidepopup';

	theme;
	themes: string[];
	selectedTheme: string;

	@Output() public sidenavToggle = new EventEmitter<any>();
	@Output() public dropdownStateChanged = new EventEmitter<any>();

	returnUrl: string;
	apiDashboardState: boolean;
	apiOauthState: boolean;
	apiTokenState: boolean;

	// private googleUser: SocialUser;
	private googleLogin: boolean;

  isKeycloakUsed: boolean;
  keycloakEndPoint: string;

  constructor(
		private route: ActivatedRoute,
		private loginService: LoginService,
		private navigationService: NavigationService,
		private themeService: ThemeService,
		private router: Router,
		private uploadService: UploadService,
    	public notificationService: NotificationService,
		// private authService: AuthService
	) {
		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
		this.login = this.loginService.loadLoginSession();
		this.loginName = (this.login ? this.login.loginName : null);
		this.loginId = (this.login ? this.login.loginId : null);

		this.apiDashboardState = getDashboardActiveState();
		this.apiOauthState = getOauthLoginActiveState();
		this.apiTokenState = getTokenActiveState();

		// if (this.apiOauthState) {
		// 	this.authService.authState.subscribe((user) => {
		// 		this.googleUser = user;
		// 		this.googleLogin = (user != null);
		// 	});
		// }

		this.profile = environment.profile;
		this.version = environment.version;
		this.guideUrl = environment.guideUrl;
		this.menuNavigation = environment.menuNavigation;

		this.theme = localStorage;
		this.themes = themeService.themes;
		themeService.changeTheme(this.selectedTheme = themeService.getTheme());

    this.isKeycloakUsed = localStorage.getItem('isKeycloakUsed') === 'true';
    this.keycloakEndPoint = environment.serviceKeycloakEndPoint;

  }

	ngOnInit() {
	}

	goBoard() {
		return this.router.navigate([ '/main', { outlets: { content: 'contentList/' + this.loginId + '/1'}}]);
	}

	public findTopMenuFromUrl(menus: any[], url: string, topMenu: any): any {
		if (menus && menus.length > 0) {
			for (const menu of menus) {
				if (menu.menuUrl === url || url.includes(menu.menuUrl)) {
					return topMenu;
				}
			}
			for (const menu of menus) {
				if (menu.children) {
					const selectedMenu = this.findTopMenuFromUrl(menu.children, url, topMenu);

					if (selectedMenu) {
						return selectedMenu;
					}
				}
			}
		}
		return null;
	}

	public onTopMenuSelected(menu: any) {
		this.selectedMenu = menu;
		this.sidenavToggle.emit(menu);
	}

	public onToggleSidenav = () => {
		if (this.selectedMenu) {
			this.sidenavToggle.emit(this.selectedMenu);
		} else if (this.menus && this.menus.length > 1) {
			const active = this.menus.filter((menu: any) => menu.visible === 'Visible');

			if (active.length > 0) {
				this.onTopMenuSelected(active[0]);
			}
		}
	}

	handleMenuVisibility(menus: any[]) {
		menus.forEach((menu: any) => {
			if (!menu.isHandled) {
				if (this.isVisible(menu)) {
					menu.visible = 'Visible';
				} else {
					menu.visible = 'Invisible';
				}
				if (menu.children) {
					this.handleMenuVisibility(menu.children);
				}

				menu.defaultName = this.getMenuName(menu);
				menu.hasChildren = this.hasChildren(menu);
				menu.isHandled = true;
			}
		});
	}

	getMenuName(menu: any) {
		let defaultName = null;
		if (menu.locales) {
			for (const locale of menu.locales) {
				if (locale.defaultState === 'Default') {
					defaultName = locale.localeName;
				}
				if (locale.code === this.loginService.getLocale()) {
					return locale.localeName;
				}
			}
		}

		return defaultName;
	}

	isVisible(menu: any): boolean {
		if (menu.visible === 'Visible') {
			if (menu.roles && environment.content && environment.content.accessRoles) {
				const roles = menu.roles.filter((role: any) => environment.content.accessRoles.includes(role.userRole));
				if (roles.length > 0) {
					for (const role of roles) {
						if (this.loginService.hasRole(role.userRole)) {
							return true;
						}
					}
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	hasChildren(menu: any): boolean {
		if (menu.children && menu.children.length > 0) {
			for (const submenu of menu.children) {
				if (submenu.visible === 'Visible') {
					return true;
				}
			}
			return false;
		} else {
			return false;
		}
	}

	doOpenUploadStatus() {
		this.uploadService.status();
	}

	goDashboardDisplay() {
		this.router.navigate([ '/main', { outlets: { content: 'dashboard/list'}}], { queryParams: { update: 'update' }});
	}

	goDashboardSetting() {
		this.router.navigate([ '/main', { outlets: { content: 'dashboard/config/setting'}}]);
	}

	goDashboardConfig() {
		this.router.navigate([ '/main', { outlets: { content: 'dashboard/config/list'}}]);
	}

	doChangeTheme(theme: string) {
		this.selectedTheme = theme;
		this.themeService.changeTheme(theme);
	}

	goHome() {
		this.router.navigate(['/home']);
	}

	toasterPopup() {
		if (this.loginService.getScreenConfig('toaster', 'toaster') === 'Subscribe') {
		this.loginService.setScreenConfig('toaster', 'toaster', 'Unsubscribe');
		this.notificationService.disconnect();
		} else {
		this.loginService.setScreenConfig('toaster', 'toaster', 'Subscribe');
		this.notificationService.connect(this.loginId);
		}
	}

	goLogout() {
		this.router.navigate(['/member/logout']);
		// window.location.href = CommonUtil.buildEndPoint(this.keycloakEndPoint, "user/logout");
	}

	svgImage() {

	}	

	goGuide() {
		window.open(this.guideUrl);
	}
}

